import React, { forwardRef, useEffect, useState } from 'react'
import { InputProps } from '.'
import { ReactComponent as CheckIcon } from '@icons/check2.svg'
import styled from 'styled-components'
import { colors } from '@styles/vars'
import useUpdateEffect from '@hooks/useUpdateEffect'

interface CheckboxProps extends InputProps {
    label: string | React.ReactNode
}

const Checkbox = ({ label, checked, defaultChecked, onChange, ...attributes }: CheckboxProps, ref: any) => {
    const [isChecked, setIsChecked] = useState(checked || defaultChecked || false)
    useUpdateEffect(() => setIsChecked(checked || false), [checked])
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(old => !old)
        onChange?.(e)
    }

    return (
        <CheckboxStyles>
            <input {...attributes} type="checkbox" checked={isChecked} onChange={handleChange} ref={ref} />
            <label htmlFor={attributes.id}>
                <div className="icon"><CheckIcon /></div>
                {label}
            </label>
        </CheckboxStyles>
    )
}

const CheckboxStyles = styled.div`
    input {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }

    label {
        display: flex;
        cursor: pointer;
        line-height: 150%;

        .icon {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 5px;
            background: ${colors.white};
            border: 1px solid ${colors.border};
            margin-right: 10px;
            transition: .2s ease-out;
            flex-shrink: 0;
            margin-top: -2px;
        }

        svg {
            display: none;
        }
    }

    input:disabled:checked + label {
        cursor: not-allowed;
        
        .icon {
            background: ${colors.greyBackgroundFocused};
        }

        svg {
            fill: ${colors.darkGrey};
        }
    }

    input:checked + label {
        .icon {
            background: ${colors.black};
        }

        svg {
            display: block;
            fill: ${colors.white};
        }
    }
`

export default forwardRef(Checkbox)